// extracted by mini-css-extract-plugin
export default {"actions":"Leads_actions__bgS9X","download":"Leads_download__QCiuf","mes":"Leads_mes__Oap31","cerrado":"Leads_cerrado__KeYif"};